/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NatureFxLightningAIcon16Light } from './NatureFxLightningAIcon16Light';
import { NatureFxLightningAIcon16Regular } from './NatureFxLightningAIcon16Regular';
import { NatureFxLightningAIcon16Solid } from './NatureFxLightningAIcon16Solid';
import { NatureFxLightningAIcon20Light } from './NatureFxLightningAIcon20Light';
import { NatureFxLightningAIcon20Regular } from './NatureFxLightningAIcon20Regular';
import { NatureFxLightningAIcon20Solid } from './NatureFxLightningAIcon20Solid';
import { NatureFxLightningAIcon24Regular } from './NatureFxLightningAIcon24Regular';
import { NatureFxLightningAIcon24Solid } from './NatureFxLightningAIcon24Solid';
import { NatureFxLightningAIcon32Regular } from './NatureFxLightningAIcon32Regular';
import { NatureFxLightningAIcon64Regular } from './NatureFxLightningAIcon64Regular';
var sizes = {
    16: {
        light: NatureFxLightningAIcon16Light,
        regular: NatureFxLightningAIcon16Regular,
        solid: NatureFxLightningAIcon16Solid,
    },
    20: {
        light: NatureFxLightningAIcon20Light,
        regular: NatureFxLightningAIcon20Regular,
        solid: NatureFxLightningAIcon20Solid,
    },
    24: {
        regular: NatureFxLightningAIcon24Regular,
        solid: NatureFxLightningAIcon24Solid,
    },
    32: {
        regular: NatureFxLightningAIcon32Regular,
    },
    64: {
        regular: NatureFxLightningAIcon64Regular,
    },
};
export var NatureFxLightningAIcon = forwardRef('NatureFxLightningAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
